import React from 'react';
import { connect } from 'react-redux';
import { portaluserResetPassword } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import MResetPasswordForm from './MResetPasswordForm';
import Modal from '../../../ui/Modal';

const actions = {
  closeModal,
  portaluserResetPassword,
};

function ModalResetPassword({ data, closeModal, portaluserResetPassword }) {
  const auth = data.auth;
  const history = data.history;
  const item = data.item;
  return (
    <Modal closeModal={closeModal}>
      <MResetPasswordForm
        auth={auth}
        history={history}
        initialValues={item}
        portaluserResetPassword={portaluserResetPassword}
        closeModal={closeModal}
      />
    </Modal>
  );
}

export default connect(null, actions)(ModalResetPassword);
